// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrandScss = require('./onbrand.scss'); //Onbrand styles
const clientScss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');

module.exports = {
  initOnbrand: function initOnbrand(translations, production) {
    // -- Startup -- //
    production ? null : onbrandUtilityFunctions.devMode(devOptions);
    $('body').prepend(htmlHeader(translations));
    $('body').append(htmlFooter(translations));
    window.onbrandLoaded = false;

    // old time embed error throw "fix" (TODO: make this better)
    onbrandUtilityFunctions.legacyEmbedTileFix();
    // Remove the "touch" class on touchscreen laptops
    onbrandUtilityFunctions.removeTouchForLaptops();
    // Remove the hub function updateOverlaySize
    onbrandUtilityFunctions.overrideHubFuctions();
    // Adds body classes for content type (blogPost, youtube, sales-stream etc)
    onbrandUtilityFunctions.helpfulClasses();
    // Rebuild the share widget for the top-nav
    onbrandUtilityFunctions.fixShareWidgetImproved();
    // warns you if your query string is missing.
    onbrandUtilityFunctions.noQueryStringSafeguard();
    // makes the reco engine sticky to the target / top of screen
    onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

    // -- Custom Functions -- //

    // -- Hub Events -- //
    const onLoadAndPageChange = function() {
      onbrandUtilityFunctions.blockCtaFix();
      onbrandUtilityFunctions.fadeOutItem();
    };

    Hubs.Events.on('load', () => {
      if (!window.onbrandLoaded) {
        onLoadAndPageChange();
        // Add your onloads here...
        console.log(`connected`);
        // end your onloads before here...
        window.onbrandLoaded = true;
      }
    })
      .on('pageChange', () => {
        onLoadAndPageChange();
      })
      .on('itemsLoaded', (itemIds, selectors) => {}) //eslint-disable-line no-unused-vars
      .on('resize', () => {
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
      })
      .on('scroll', () => {
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
      })
      .on('ctaActivate', (ctaId) => {}) //eslint-disable-line no-unused-vars
      .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {}) //eslint-disable-line no-unused-vars
      .on('search', () => {});

    // The new hub events can trigger before cihost scripts are loaded.
    // This will ensure your scripts fire no matter what, but not more than once for 'load'.
    if (!window.onbrandLoaded) {
      Hubs.Events.trigger('load');
    }
  },
};



// WEBPACK FOOTER //
// ./onbrand.js